import { KapchargeStatusCounts } from '@lmc-app/core/services/payment-processing.service';
import { StatusBreakdownItem } from '@lmc-app/shared/components/status-breakdown/status-breakdown.component';
import { KapchargeTransactionStatus } from '@lmc-app/shared/enum/kapcharge-transaction-status.enum';

/**
 * Per-status breakdown for KapCharge transaction summaries: maps each batch
 * count field to its status and legend label. Colors are resolved from the
 * shared palette (KAPCHARGE_STATUS_COLORS) so the breakdown legend and the
 * table status badges stay in sync across the feature.
 */
export const KAPCHARGE_STATUS_BREAKDOWN: ReadonlyArray<{
  key: keyof KapchargeStatusCounts;
  status: KapchargeTransactionStatus;
  label: string;
}> = [
  { key: 'queuedCount', status: KapchargeTransactionStatus.Queued, label: 'Queued' },
  { key: 'initiatedCount', status: KapchargeTransactionStatus.Initiated, label: 'Initiated' },
  { key: 'processingCount', status: KapchargeTransactionStatus.Processing, label: 'Processing' },
  { key: 'acceptedCount', status: KapchargeTransactionStatus.Accepted, label: 'Accepted' },
  { key: 'returnedCount', status: KapchargeTransactionStatus.Returned, label: 'Returned' },
  { key: 'cancelledCount', status: KapchargeTransactionStatus.Cancelled, label: 'Cancelled' },
  { key: 'invalidCount', status: KapchargeTransactionStatus.Invalid, label: 'Invalid' },
  // errorCount groups Error + TxnError (see ERROR_STATUSES in the backend); both are
  // presented as plain "Error", and picking Error in the status filter returns exactly
  // this chip's rows.
  { key: 'errorCount', status: KapchargeTransactionStatus.Error, label: 'Error' },
];

/**
 * Maps any set of status counts — a whole batch, or one of its per-due-date summaries — to
 * the item list consumed by <lmc-status-breakdown>.
 */
export function kapchargeStatusItems(counts: KapchargeStatusCounts): StatusBreakdownItem[] {
  return KAPCHARGE_STATUS_BREAKDOWN.map((s) => ({
    label: s.label,
    color: KapchargeTransactionStatus.getColor(s.status),
    count: Number(counts[s.key] ?? 0),
  }));
}